



















































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  Barcode,
  POSContact,
  POSPayment,
  POSProductTypeData,
  POSSession,
  POSTicketDetail,
  POSTicketEposPrinter,
} from '@pos/interfaces/pos-v2';
import BpcPosPrintTicket from '@pos/components/v2/pos-print-ticket.vue';
import BpcPosPrintBarcode from '@pos/components/v2/pos-print-barcode.vue';
// import PrintTicket from '@accounting/components/details/print-ticket/print-ticket.vue';
import BpcHtmlToPrinter from '@shared/components/html-to-printer/html-to-printer.vue';
import BpcPosSendTicketByEmailModal from '@pos/components/v2/pos-send-ticket-by-email-modal.vue';
import EpsonEposPrinterService, {
  printType,
  useEpsonEposPrinterService,
} from '@pos/services/epson-epos-printer-service';

@Component({
  name: 'bpc-pos-ticket-actions',
  components: {
    // 'bpc-html-to-printer': HtmlToPrinter,
    // 'bpc-print-ticket': PrintTicket,
    BpcHtmlToPrinter,
    BpcPosPrintTicket,
    BpcPosPrintBarcode,
    BpcPosSendTicketByEmailModal,
  },
})
export default class PosTicketActions extends Vue {
  $refs!: {
    htmlToPrinter: InstanceType<typeof BpcHtmlToPrinter> & {
      printContent: () => void;
    };
    htmlBarcodeToPrinter: InstanceType<typeof BpcHtmlToPrinter> & {
      printContent: () => void;
    };
    htmlDrawerToPrinter: InstanceType<typeof BpcHtmlToPrinter> & {
      printContent: () => void;
    };
  };
  @Prop({ type: Object, required: true })
  readonly ticketDetail: POSTicketDetail;
  @Prop({ type: Array, required: true })
  readonly ticketProductTypes: POSProductTypeData[];
  @Prop({ type: Object, required: true }) readonly posSession: POSSession;
  @Prop({ type: Object, required: true }) readonly contact: POSContact;
  @Prop({ type: String, default: 'print' }) readonly printButtonIcon: string;
  @Prop({ type: String, default: 'envelope' }) readonly sendButtonIcon: string;

  printing = false;
  printingTicket = false;
  printingBarcode = false;
  openingDrawer = false;
  closing = false;
  markingAsPaid = false;
  reopening = false;
  barcodes = [];
  showCloseModalConfirmation = false;
  showMarkAsPaidModalConfirmation = false;
  alreadyPrinted = false;
  barcodeAlreadyPrinted = false;
  openSendTicketByEmail = false;
  showPrintBarcodeBlockedWindowModal = false;
  showPrintTicketBlockedWindowModal = false;
  // FIXME: modify this link to the correct one
  blockedWindowFaqUrl = 'https://fr.wikihow.com/autoriser-les-fen%C3%AAtres-pop%E2%80%91ups';
  eposPrinterService: EpsonEposPrinterService;
  mounted() {
    this.eposPrinterService = useEpsonEposPrinterService();
  }

  // COMPUTED
  get cashierName() {
    return this.posSession.cashierName;
  }

  get ticketId() {
    return this.ticketDetail.id;
  }

  get centerAllowSendingTicket() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].send_invoice_from_pos
      : false;
  }

  get barcodesToPrint(): Barcode[] {
    return this.barcodes.filter(barcode => !barcode.printWithCard);
  }

  get barcodesToDownload(): Barcode[] {
    return this.barcodes.filter(barcode => barcode.printWithCard);
  }

  onPrintBarcodeWindowBlocked() {
    this.showPrintBarcodeBlockedWindowModal = true;
  }
  onPrintTicketWindowBlocked() {
    this.showPrintTicketBlockedWindowModal = true;
  }

  onOpenSendTicketByEmail() {
    this.openSendTicketByEmail = true;
  }

  async printTicket() {
    if (
      this.posSession.printerType === 'epos' &&
      this.posSession.printerIpAddress &&
      this.eposPrinterService.isAvailable()
    ) {
      const ticketData = {
        code: this.ticketDetail.code,
        total: this.ticketDetail.total,
        date: this.ticketDetail.date,
        products: [],
        payments: [],
      };

      this.ticketDetail.productTypes?.forEach((productType: POSProductTypeData) => {
        productType.products?.forEach((product: any) => {
          ticketData['products'] = [...ticketData['products'], product];
        });
      });

      this.ticketDetail.payments?.forEach((payment: POSPayment) => {
        ticketData['payments'] = [
          ...ticketData['payments'],
          {
            payment_date: payment.payment_date,
            payment_method: payment.payment_method_type,
            payment_amount: payment.paid_amount,
          },
        ];
      });
      await this.printWithEposPrinter(this.posSession.printerIpAddress, ticketData, 'ticket');
    } else {
      await this.printTicketWithNormalPrinter();
    }
  }

  async printWithEposPrinter(
    printerIpAddress: string,
    data: Barcode[] | POSTicketEposPrinter,
    type: printType,
  ) {
    this.printingTicket = !this.printingTicket ? type === 'ticket' : this.printingTicket;
    this.printingBarcode = !this.printingBarcode ? type === 'badge' : this.printingBarcode;
    try {
      await this.eposPrinterService.handlePrint(printerIpAddress, data, type);
      this.$bpcMessage.showSuccessMessage({ text: 'global.ticket_print_epos_success' });
    } catch (error) {
      this.$bpcMessage.showErrorMessage({ text: 'global.ticket_print_epos_error' });
      // In case of error, print as normal printer
      if (type === 'ticket') {
        await this.printTicketWithNormalPrinter();
      } else {
        await this.printBarcodeWithNormalPrinter();
      }
    } finally {
      this.printingTicket = false;
      this.printingBarcode = false;
    }
  }

  async printTicketWithNormalPrinter() {
    this.barcodes = [];
    if (this.ticketDetail.hasBarcode) {
      this.barcodes = await this.$posService.getTicketBarcodes(
        this.posSession.id,
        this.ticketDetail.id,
      );
    }
    await this.$nextTick();
    await this.$refs.htmlToPrinter.printContent();
  }

  async printBarcodeWithNormalPrinter() {
    await this.$nextTick();
    await this.$refs.htmlBarcodeToPrinter.printContent();
  }

  async printBarcode() {
    this.barcodes = [];
    if (this.ticketDetail.hasBarcode) {
      this.barcodes = await this.$posService.getTicketBarcodes(
        this.posSession.id,
        this.ticketDetail.id,
      );
    }

    if (this.barcodesToPrint.length) {
      if (
        this.posSession.printerType === 'epos' &&
        this.posSession.printerIpAddress &&
        this.eposPrinterService.isAvailable()
      ) {
        await this.printWithEposPrinter(
          this.posSession.printerIpAddress,
          this.barcodesToPrint,
          'badge',
        );
      } else {
        await this.printBarcodeWithNormalPrinter();
      }
    }

    if (this.barcodesToDownload.length) {
      console.log(this.barcodesToDownload);
      const entryIds = this.barcodesToDownload.map((item: Barcode) => item.productId);
      const basePath = this.$bpcApiRouteHelper.getEntityPath('entry');
      const relativePath = '/download-cards/';
      const params = {
        ids: entryIds,
        filename: this.ticketDetail.code,
      };
      this.$bpcApi.postDownload(`${basePath + relativePath}`, '', { ...params }).subscribe(res => {
        console.log(res);
      });
    }
  }

  async onClose() {
    this.closing = true;
    if (this.ticketDetail.status === 'paid') {
      this.closeTicket();
    } else {
      this.showCloseModalConfirmation = true;
    }
  }

  async closeTicket() {
    this.closing = true;
    try {
      const ticket = await this.$posService.closeTicket(this.posSession.id, this.ticketDetail.id);

      this.$emit('ticket-closed', ticket);
    } catch (error) {
      this.$bpcMessage.showErrorMessage({ text: 'pos.ticket_close_error' });
    }
    this.closing = false;
  }

  onCloseCancelled() {
    this.resetInitialValues();
  }

  resetInitialValues() {
    this.printing = false;
    this.printingTicket = false;
    this.printingBarcode = false;
    this.openingDrawer = false;
    this.closing = false;
    this.markingAsPaid = false;
    this.reopening = false;
    this.barcodes = [];
    this.showCloseModalConfirmation = false;
    this.showMarkAsPaidModalConfirmation = false;
    this.alreadyPrinted = false;
    this.barcodeAlreadyPrinted = false;
  }

  onMarkAsPaid() {
    this.showMarkAsPaidModalConfirmation = true;
  }
  async onMarkAsPaidConfirmed() {
    this.markingAsPaid = true;
    try {
      const ticket = await this.$posService.markAsPaidTicket(
        this.posSession.id,
        this.ticketDetail.id,
      );
      this.$emit('ticket-marked-as-paid', ticket);
    } catch (error) {
      this.resetInitialValues();
      this.$bpcMessage.showErrorMessage({
        text: 'pos.ticket_mark_as_paid_error',
      });
    }
    // this.markingAsPaid = false;
  }
  onMarkAsPaidCancelled() {
    this.resetInitialValues();
  }
  onReopen() {
    // TODO implement onReopen
  }

  checkIfTicketChangedToPaid(
    newTicketDetail: POSTicketDetail,
    oldTicketDetail: POSTicketDetail,
  ): boolean {
    return (
      newTicketDetail &&
      oldTicketDetail &&
      oldTicketDetail.id === newTicketDetail.id &&
      oldTicketDetail.status !== newTicketDetail.status &&
      newTicketDetail.status === 'paid'
    );
  }

  async applyAfterPaymentActions() {
    if (
      this.ticketDetail.hasBarcode &&
      !this.barcodeAlreadyPrinted &&
      this.posSession.printBarcodeAfterPayment
    ) {
      this.barcodeAlreadyPrinted = true;
      await this.printBarcode();
    }

    if (!this.alreadyPrinted && this.posSession.printAfterPayment) {
      this.alreadyPrinted = true;
      await this.printTicket();
      await this.applyAfterPaymentActions();
    }

    if (this.posSession.closeAfterPayment) {
      this.closeTicket();
    }
  }
  @Watch('ticketDetail')
  onTicketDetailChanged(newTicketDetail: POSTicketDetail, oldTicketDetail: POSTicketDetail) {
    if (this.checkIfTicketChangedToPaid(newTicketDetail, oldTicketDetail)) {
      this.applyAfterPaymentActions();
    } else if (oldTicketDetail.id !== newTicketDetail.id) {
      this.resetInitialValues();
    }
  }

  async openDrawerWithNormalPrinter() {
    // For normal printers, we need to create a minimal print job to open the drawer
    // This will use the html-to-printer component with a blank page
    this.openingDrawer = true;
    try {
      await this.$nextTick();
      await this.$refs.htmlDrawerToPrinter.printContent();
      this.$bpcMessage.showSuccessMessage({ text: 'global.drawer_open_success' });
    } catch (error) {
      this.$bpcMessage.showErrorMessage({ text: 'global.drawer_open_error' });
    } finally {
      this.openingDrawer = false;
    }
  }

  async openDrawer() {
    if (
      this.posSession.printerType === 'epos' &&
      this.posSession.printerIpAddress &&
      this.eposPrinterService.isAvailable()
    ) {
      // EPOS printer: use the EPOS service with pulse only
      console.log(
        `Drawer opening - Printer Type: ${this.posSession.printerType} | Method: EPOS pulse only (no printing)`,
      );
      this.openingDrawer = true;
      try {
        await this.eposPrinterService.handlePrint(this.posSession.printerIpAddress, null, 'drawer');
        this.$bpcMessage.showSuccessMessage({ text: 'global.drawer_open_success' });
      } catch (error) {
        this.$bpcMessage.showErrorMessage({ text: 'global.drawer_open_error' });
      } finally {
        this.openingDrawer = false;
      }
    } else {
      // Normal printer: use html-to-printer with minimal content
      console.log(
        `Drawer opening - Printer Type: ${this.posSession.printerType ||
          'normal/other'} | Method: Minimal print + drawer trigger`,
      );
      await this.openDrawerWithNormalPrinter();
    }
  }
}
